module.exports = __webpack_public_path__ + "media/application/images/brand/logo--vertical-7bfdfdf036ad0376707957c3e474f5aa.png";